import { SceneContainer } from '../components/scene/SceneContainer'
import { ManageProfile } from '../components/personal/ManageProfile'

function ProfileScreen() {
  return (
    <SceneContainer
      title="My profile"
      description="Manage your personal details"
    >
      <ManageProfile />
    </SceneContainer>
  )
}

export default ProfileScreen
